module.exports = __webpack_public_path__ + "static/media/Nsign.05f6e556.png";